// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3fm7s","col":"styles_col__2OabN"};